import { css } from 'goober';
import { isEmpty } from 'mc-ui-utils';
import React, { memo, useEffect, } from 'react';
import { getViewPortDimensions } from '../../../utils/common';
import { onGlanceShown, setImpressionId } from '../../../utils/khazaddumbridge';
const { vh } = getViewPortDimensions();
const Bg = css `
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom center;
  width: 100%;
  min-height: 100vh;
  height: ${vh};
  position: absolute;
  will-change: opacity;
  opacity: 1;
  overflow: hidden;
  background-image: var(--background-image, 'none');
  &.should-not-render {
    opacity: 0;
    pointer-events: none;
  }
`;
const Overlay = css `
  display: block;
  position: absolute;
  width: 100%;
  top: 0;
  max-height: fill-available;
`;
const Background = (props) => {
    const { image, overlayImage, isActive, children, glanceId, shouldRender, isAWebpeek, webpeekLoaded, impressionId, isAnArticle, isHomeVisible, informStateUpdatedOnInvisible, } = props;
    useEffect(() => {
        /**
         * we are not adding isActive as a dependency as we want this useEffect to be executed
         * when isHomeVisible is changed from true to false.
         * we do not want this to run whenever isActive changes.
         */
        if (!isHomeVisible && isActive && isAnArticle) {
            informStateUpdatedOnInvisible();
        }
    }, [isHomeVisible]);
    useEffect(() => {
        if (isActive) {
            /****
             * Call SDK JS bridge to mark this glance as shown
             */
            onGlanceShown(glanceId);
            setImpressionId(impressionId);
        }
    }, [isActive, glanceId]);
    const style = image
        ? { '--background-image': `url('${image}')` }
        : {};
    return (React.createElement("article", { className: `${Bg}${shouldRender ? '' : ' should-not-render'}`, style: style, "data-glanceid": glanceId },
        !isEmpty(overlayImage) &&
            overlayImage &&
            (!isAWebpeek || (isAWebpeek && !webpeekLoaded)) && (React.createElement("img", { className: Overlay, src: overlayImage })),
        children));
};
const shouldNotRender = (prevProps, nextProps) => {
    return !((prevProps.isActive ||
        nextProps.isActive ||
        prevProps.shouldRender !== nextProps.shouldRender ||
        prevProps.shouldPreload !== nextProps.shouldPreload) // shouldPreload is introduced to preload next Native videos
    );
};
export default memo(Background, shouldNotRender);
//# sourceMappingURL=index.js.map